import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { InquiryForm } from './InquiryForm';
const APART = ['No large entrance fees', 'Own your residence and build equity', 'Choose your own healthcare providers', '50-acre private community'];
export function Hero() {
  return <section id="connect" className="relative w-full overflow-hidden bg-forest" data-id="element-69" data-mp="4n1lqsntuet1">
      <img src="https://cdn.magicpatterns.com/uploads/hv6VjKJTrCcdypHRXLng6i/731093945_1642987334500819_6320779057842076688_n.png" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-15" data-id="element-70" data-mp="129qudld1bpnv" />
      <div className="absolute inset-0 bg-gradient-to-b from-forest-dark/70 to-forest" aria-hidden="true" data-id="element-71" data-mp="sd47ys528qjq" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-5 py-16 lg:grid-cols-[1.35fr_1fr] lg:gap-12 lg:px-8 lg:py-24" data-id="element-72" data-mp="3d1scx40hhvwa">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-73" data-mp="3814alm6t1smr">
          <span className="text-base font-semibold uppercase tracking-[0.2em] text-gold-light" data-id="element-74" data-mp="399jmzcfv4d5l">
            A One-of-a-Kind Community
          </span>
          <h1 className="mt-4 font-display text-white text-4xl sm:text-5xl lg:text-[56px]" data-id="element-75" data-mp="30i17l3qqq1dk">
            Luxury Independent Living in Baltimore County
          </h1>
          <p className="mt-7 max-w-xl font-serif text-xl leading-relaxed text-white/85 lg:text-2xl" data-id="element-76" data-mp="35aax4iny0zfb">
            At Brightwood, you own your home and keep your healthcare choices.
            Enjoy an independent senior community designed for adults 62+ who
            want freedom, comfort, and control over their future.
          </p>

          <div className="mt-10" data-id="element-77" data-mp="2lkqwhvi0exid">
            <p className="font-display text-2xl text-gold-light" data-id="element-78" data-mp="2ljpcv2mxh2p1">
              What Sets Brightwood Apart
            </p>
            <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-79" data-mp="s3mfk97g6b1j">
              {APART.map(item => <li key={item} className="flex items-start gap-3 text-white/90" data-id="element-80" data-mp="n9qf903poc37">
                  <span className="mt-0.5 flex h-7 w-7 flex-none items-center justify-center rounded-full bg-gold" data-id="element-81" data-mp="id02aln7dwm0">
                    <CheckIcon className="h-4 w-4 text-forest-dark" data-id="element-82" data-mp="deyks55fe5cn" />
                  </span>
                  <span className="text-lg leading-snug" data-id="element-83" data-mp="1b0dt020b5vxo">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-84" data-mp="1126o4hjan4c1">
          <InquiryForm variant="light" data-id="element-85" data-mp="3hqu1e72ly1zl" />
        </motion.div>
      </div>
    </section>;
}